var _dec, _class, _DrilldownOption;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { Component } from 'react';
import { withStyle } from '@instructure/emotion';
import { optionsItemThemeGenerator } from '@instructure/ui-options';
import { allowedProps } from "./props.js";
/**
---
parent: Drilldown
id: Drilldown.Option
---
@module DrilldownOption
**/
// needed for listing the available theme variables on docs page,
// we pass the themeOverrides to Options.Item
let DrilldownOption = (_dec = withStyle(null, optionsItemThemeGenerator), _dec(_class = (_DrilldownOption = class DrilldownOption extends Component {
  render() {
    // this component is only used for prop validation. Drilldown.Option children
    // are parsed in Drilldown and rendered as Options.Item components
    return null;
  }
}, _DrilldownOption.displayName = "DrilldownOption", _DrilldownOption.componentId = 'Drilldown.Option', _DrilldownOption.allowedProps = allowedProps, _DrilldownOption.defaultProps = {
  disabled: false,
  beforeLabelContentVAlign: 'start',
  afterLabelContentVAlign: 'start',
  as: 'li',
  role: 'menuitem',
  shouldCloseOnClick: 'auto'
}, _DrilldownOption)) || _class);
export default DrilldownOption;
export { DrilldownOption };